import Url from 'urlinator/Url';
import { getQueryParam } from '../routing/getQueryParam';
export default function getAppFromLoginRedirectUrl() {
  const loginRedirectUrl = getQueryParam('loginRedirectUrl');

  if (!loginRedirectUrl) {
    return null;
  }

  const clientId = new Url(loginRedirectUrl).params['client_id'];
  return clientId || null;
}